
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Bushireforcorporatepicnicinpune() {



const cardData =
{
  keyword: 'Bus Hire for Corporate Picnic in Pune',
  heading: 'eTravo: Reliable and Spacious Bus Hire for Corporate Picnics in Pune',
  headingDescription: 'Organizing a corporate picnic in Pune? eTravo offers specially curated bus hire services designed for team outings, staff day trips, and employee excursions. Our fleet of clean, air-conditioned buses—ranging from 17-seater minibuses to 50-seater luxury coaches—ensures safe, punctual, and comfortable group transportation. Whether you’re heading to a hillside fort, lakeside retreat, or a private resort, we provide door-to-door pickup, route planning, and professional drivers for a seamless experience. Make your next corporate picnic enjoyable from the journey itself with eTravo’s dependable bus services.',

  top: 'Top Picnic Spots in and Around Pune for Corporate Bus Travel',
  topPlaces: [
    {
      title: 'Mantra Resort',
      description: 'A resort nestled near Bhatghar Dam, ideal for corporate teams looking for activities, food, and open space. eTravo’s 30+ seater buses can handle large staff groups with round-trip service, meal stops, and on-demand driver availability for extra coordination.'
    },
    {
      title: 'Panshet Dam',
      description: 'A tranquil destination popular for outdoor picnics and team games. Our buses ensure early morning departures and timely return for sunset views, with provisions for multiple boarding points across Pune.'
    },
    {
      title: 'Mulshi Lake',
      description: 'Known for scenic beauty and cool breezes, this spot is excellent for unwinding. Our large buses accommodate employee groups, providing soft suspension for hilly roads and optional restroom stopovers en route.'
    },
    {
      title: 'Sinhagad Fort',
      description: 'A combination of history and nature, Sinhagad is a popular picnic spot. eTravo’s experienced drivers are familiar with the winding roads and ideal parking spots to ensure a stress-free outing.'
    },
    {
      title: 'Lavasa City',
      description: 'A picturesque hill-town ideal for team-building activities and resort day-outs. Our AC buses are equipped for the curvy ghat sections and we offer flexible return timings based on your itinerary.'
    },
    {
      title: 'Khadakwasla Backwaters',
      description: 'Perfect for morning picnics and informal corporate events. eTravo provides pickup from different office locations and offers buses with wide windows for scenic viewing.'
    },
    {
      title: 'Rajiv Gandhi Zoological Park',
      description: 'Located in Katraj, this is ideal for shorter picnic hours and team bonding. We offer smaller buses for compact teams with tight schedules and provide driver assistance for return coordination.'
    },
    {
      title: 'Peacock Bay',
      description: 'Often used for peaceful team meetups by the lake, this area near NDA Pune is accessible with our mid-sized buses that allow easy maneuvering through the restricted terrain.'
    },
    {
      title: 'Gram Sanskruti Udyan',
      description: 'For local staff outings, this cultural village park offers unique engagement. Our buses ensure multiple pickup options across Pune, especially for teams staying within city limits.'
    },
    {
      title: 'JadhavGADH Fort Heritage Resort',
      description: 'Combining heritage and luxury, it’s a top pick for executive retreats. eTravo’s luxury buses are ideal for transporting teams in comfort to this premium picnic destination.'
    }
  ],

  services: [
    {
      name: 'Pune Corporate Picnic Bus Rental',
      description: 'Book our corporate picnic buses for one-day or multi-day outings across Pune and nearby destinations. We offer complete itinerary-based service, ensuring timely arrival, designated halts, and flexible return planning.'
    },
    {
      name: 'Staff Picnic Bus Hire Pune',
      description: 'Choose from 17 to 50-seater buses tailored for staff outings. Our services include pre-picnic coordination, onboard assistance for HR, and door-to-door transport from multiple office hubs or employee residences.'
    },
    {
      name: 'AC Bus Rental for Corporate Outings Pune',
      description: 'Our fleet includes air-conditioned buses with plush seating, large windows, and ample space for team equipment, food, and games. Ideal for summer picnics or long-distance trips.'
    },
    {
      name: 'Affordable Bus Hire for Corporate Picnic Pune',
      description: 'We offer budget-friendly bus packages without compromising service. From fixed pricing per kilometer to full-day rental options, our transparent billing supports your company’s travel planning.'
    },
    {
      name: 'Corporate Team Outing Bus Services Pune',
      description: 'For HR teams organizing large team events, we provide scheduling tools, extra support staff on request, and staggered drop-off options post-event—all at no extra hassle.'
    },
    {
      name: 'Employee Picnic Bus Transport Pune',
      description: 'Move your staff efficiently to and from the venue with our reliable bus transport service. Includes GPS tracking, verified drivers, emergency support, and real-time route updates.'
    },
    {
      name: 'Luxury Bus Rental for Picnic Pune',
      description: 'For executive or premium team outings, our luxury coaches offer reclining seats, USB charging, audio-video systems, and travel kits. Ideal for high-end resort visits or leadership retreats.'
    },
    {
      name: 'Corporate Event Bus Hire Pune',
      description: 'Planning an employee awards day, team-building camp, or outdoor seminar? eTravo buses are perfect for transporting large teams to event locations with coordinated dispatch timing and standby vehicles.'
    },
    {
      name: 'Comfortable Staff Picnic Bus Pune',
      description: 'Comfort is key during long picnic trips. Our buses provide ample legroom, neat interiors, and suspension systems suited for highway and ghat travel. Water bottles and music can be arranged on request.'
    },
    {
      name: 'Group Bus Hire for Corporate Picnic Pune',
      description: 'Need multiple buses for your entire department or company? We manage multi-vehicle dispatch, lead bus coordination, and ensure team-wise seating with printed lists if required.'
    },
    {
      name: 'Reliable Picnic Bus Rentals Pune',
      description: 'Known for punctuality, clean vehicles, and customer-friendly drivers, eTravo’s buses come with reliability guaranteed. Our 24/7 helpline ensures you’re never left waiting or stranded.'
    },
    {
      name: 'Business Picnic Shuttle Bus Pune',
      description: 'For recurring staff events or tiered group travel, our shuttle buses operate on shift-wise pickup schedules with wait-and-return options. Perfect for large companies with staggered picnic departures.'
    },
    {
      name: 'Bus Hire for Employee Excursions Pune',
      description: 'Whether it’s an appreciation outing or festive celebration, we ensure your employees are transported safely and joyfully, with options to book meals, music, and even roadside halts.'
    },
    {
      name: 'Staff Group Bus Rental Pune',
      description: 'Designed for internal department-level outings, our buses can be booked per group, ensuring smooth coordination, fixed return times, and pick-drop at predefined localities.'
    },
    {
      name: 'Corporate Picnic Transportation Pune',
      description: 'Complete transport solution for your next team picnic — from planning and route mapping to driver contact and trip monitoring. Ideal for HR and Admin professionals seeking reliability and ease.'
    }
  ],

  tableData: [
    ['Pune Corporate Picnic Bus Rental', 'Staff Picnic Bus Hire Pune'],
    ['AC Bus Rental for Corporate Outings Pune', 'Affordable Bus Hire for Corporate Picnic Pune'],
    ['Corporate Team Outing Bus Services Pune', 'Employee Picnic Bus Transport Pune'],
    ['Luxury Bus Rental for Picnic Pune', 'Corporate Event Bus Hire Pune'],
    ['Comfortable Staff Picnic Bus Pune', 'Group Bus Hire for Corporate Picnic Pune'],
    ['Reliable Picnic Bus Rentals Pune', 'Business Picnic Shuttle Bus Pune'],
    ['Bus Hire for Employee Excursions Pune', 'Staff Group Bus Rental Pune'],
    ['Corporate Picnic Transportation Pune', '']
  ],



"whychoose": [
    {
        "WhyChooseheading": "Spacious Bus Options for Corporate Picnics",
        "WhyChoosedescription": "eTravo provides a wide range of buses from 20 to 50 seaters, perfectly suited for transporting large corporate teams to picnic spots around Pune. Whether you’re organizing a single-day offsite or a weekend retreat, our buses offer comfort, safety, and efficient group coordination for every outing."
    },
    {
        "WhyChooseheading": "Comfortable Travel Experience with Premium Amenities",
        "WhyChoosedescription": "Our buses are air-conditioned, equipped with cushioned pushback seats, ample legroom, curtains, charging ports, and onboard entertainment systems. These features make long trips to destinations like Lonavala, Lavasa, or Mulshi enjoyable and relaxing, ensuring your employees arrive refreshed and ready for fun."
    },
    {
        "WhyChooseheading": "Expert Coordination for Group Transport Logistics",
        "WhyChoosedescription": "We handle end-to-end transport planning including scheduling, route mapping, and coordinating multiple pickup points across Pune city. Our event transport team works with your HR or admin staff to ensure that all employees are picked up and dropped off smoothly and on time."
    },
    {
        "WhyChooseheading": "Trained Drivers with Route Knowledge of Picnic Spots",
        "WhyChoosedescription": "Our drivers are experienced in handling group trips and are well-versed with the routes to all major picnic and hill station destinations around Pune. They ensure safe, punctual, and smooth rides, and follow company protocols for corporate events."
    },
    {
        "WhyChooseheading": "All-Inclusive Packages with Transparent Pricing",
        "WhyChoosedescription": "We offer easy-to-understand, all-inclusive packages that cover driver allowances, fuel, tolls, and parking fees. There are no hidden charges, and our transparent invoices make it easy for your finance department to approve and reimburse the trip costs."
    },
    {
        "WhyChooseheading": "Fully Sanitized Buses with Safety Features",
        "WhyChoosedescription": "All our buses are cleaned before every trip and undergo thorough sanitization. Each vehicle includes essential safety features like fire extinguishers, first-aid kits, and seat belts, ensuring a safe journey for your team members and guests."
    },
    {
        "WhyChooseheading": "Flexible Pickup and Drop Arrangements",
        "WhyChoosedescription": "Whether your team is located in different parts of Pune or staying in guest houses, we arrange custom pickup and drop points that suit your convenience. This flexibility allows you to cover more employees and maximize participation in the picnic."
    },
    {
        "WhyChooseheading": "GST-Compliant Invoicing with Detailed Ride Logs",
        "WhyChoosedescription": "We provide clear, itemized, and GST-compliant invoices for easy processing and documentation. Every trip comes with a summary of bus usage, timings, and total headcount—perfect for internal reporting and audit trails."
    }
]
}


const faqData = [
    [
        {
            question: 'What bus sizes are available for corporate picnic trips?',
            answer: 'We offer a range of AC and non-AC buses, including 20-seater, 32-seater, 40-seater, and 50-seater options for transporting teams of all sizes.'
        },
        {
            question: 'Can we customize pickup and drop points across Pune?',
            answer: 'Yes, we provide customized routing with multiple pickup and drop locations to suit the convenience of your employees.'
        },
        {
            question: 'Are the buses equipped with music or entertainment systems?',
            answer: 'Yes, many of our buses include audio systems and speakers for music. You can also request Bluetooth or AUX-enabled options.'
        },
        {
            question: 'Is food or snacks allowed inside the buses?',
            answer: 'Yes, light food and snacks are allowed. We request that trash be disposed of responsibly to maintain hygiene throughout the trip.'
        },
        {
            question: 'Do your drivers have experience with long-distance trips?',
            answer: 'Absolutely. Our drivers are trained in long-route driving and are familiar with popular picnic destinations such as Sinhagad, Mulshi, and Lavasa.'
        },
        {
            question: 'Will we receive a GST invoice for the picnic bus rental?',
            answer: 'Yes, every booking includes a GST-compliant invoice with detailed cost breakdowns for easy reimbursement and accounting.'
        }
    ]
];


const testimonialsData = [
    {
        name: 'Mr. Abhijeet Naik',
        designation: 'HR Head, SpectraTech Systems',
        rating: [1, 1, 1, 1, 1],
        text: '“We booked two 45-seater buses from eTravo for our team’s annual outing to Lavasa. The service was flawless, buses were clean and spacious, and the drivers were extremely courteous.”'
    },
    {
        name: 'Ms. Jyoti Mhatre',
        designation: 'Admin Manager, NovaMed India Pvt. Ltd.',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo helped us plan and execute a perfect corporate picnic. Their transport coordination, timely pickups, and clean buses made the event stress-free and enjoyable.”'
    }
];




















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire for Corporate Picnic in Pune",
  "image": "https://www.etravo.in/images/keyword/corporate-picnic-bus-pune.jpg",
  "description": "Book bus hire for corporate picnics in Pune with eTravo. Comfortable and affordable AC buses for staff outings, corporate events, and group excursions. Reliable and luxury bus services for your corporate picnic transport needs.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7564"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5499",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/bus-hire-for-corporate-picnic-pune"
  }
};







    return (
        <div>
<Helmet>
  <title>Bus Hire for Corporate Picnic in Pune | Staff Outing & Group Transport | eTravo</title>
  <meta 
    name="description" 
    content="Hire comfortable and affordable buses for corporate picnics in Pune. AC bus rentals for staff outings, group events, and corporate trips with professional drivers by eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/49.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bushireforcorporatepicnicinpune;